const roleClaim = 'https://salespartner.rikstv.no/roles'

export const isUserAdmin = user => user[roleClaim].includes('admin')
export const isPortalUserAdmin = user => user.app_metadata.roles && user.app_metadata.roles.includes('admin')
